import {ReactNode} from 'react';

import {HeaderButtonCommonProps} from '@/shared/components/Header';
import {TIARA_ACTION} from '@/shared/constants/tiara';

export type ConfirmButtonProps = HeaderButtonCommonProps & {
  disabled: boolean;
  startAdornment: ReactNode;
};

const ConfirmButton = ({onClick, trackEvent, disabled, startAdornment}: ConfirmButtonProps) => {
  return (
    <button
      type="button"
      className="btn_txt"
      disabled={!!disabled}
      onClick={(e) => {
        trackEvent({action: TIARA_ACTION.CONFIRM_CLICK});
        onClick?.(e);
      }}
    >
      {startAdornment}
      <span className="icon txt_btn">확인</span>
    </button>
  );
};
export default ConfirmButton;
